import { motion } from "framer-motion";
import { ArrowRight, Check } from "lucide-react";

const reveal = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } },
};

export const Pricing = ({ t, onNavigate }) => {
    const p = t.pricing;
    return (
        <section id="pricing" className="scroll-mt-28 bg-white py-24 md:py-32" data-testid="pricing-section">
            <div className="mx-auto max-w-[1200px] px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.25 }}
                    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    className="relative overflow-hidden rounded-[2.5rem] bg-[#032A44] px-8 py-12 shadow-[0_40px_100px_rgba(3,42,68,0.35)] md:px-14 md:py-16"
                    data-testid="pricing-card"
                >
                    <div aria-hidden="true" className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#14778D]/20 blur-[110px]" />
                    <div aria-hidden="true" className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#EDCD7C]/15 blur-[110px]" />

                    <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
                        <div>
                            <p className="text-xs font-bold uppercase tracking-[0.26em] text-[#F59E0B] md:text-sm" data-testid="pricing-overline">
                                {p.bandOverline}
                            </p>
                            <h2 className="font-display mt-4 text-4xl leading-tight tracking-tight text-white md:text-5xl" data-testid="pricing-title">
                                {p.title}
                            </h2>
                            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#94A3B8] md:text-base" data-testid="pricing-text">
                                {p.bandText}
                            </p>
                            <ul className="mt-7 space-y-3" data-testid="pricing-points">
                                {p.checks.map((c) => (
                                    <li key={c} className="flex items-center gap-3 text-sm font-semibold text-[#E2E8F0]">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0D9488]/25">
                                            <Check size={12} className="text-[#5EEAD4]" />
                                        </span>
                                        {c}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="flex flex-col items-start gap-6 lg:items-end lg:text-right">
                            <div>
                                <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#94A3B8]">{p.thenLabel}</p>
                                <p className="mt-2 flex items-baseline gap-2 lg:justify-end">
                                    <span className="text-5xl font-extrabold tracking-tight text-white md:text-6xl" data-testid="pricing-price">
                                        {p.price}
                                    </span>
                                    <span className="text-base font-semibold text-[#94A3B8]">/ {p.perMonth}</span>
                                </p>
                            </div>
                            <button
                                onClick={() => onNavigate("download")}
                                className="group flex items-center gap-3 rounded-full bg-[#D97706] px-8 py-4 text-sm font-bold text-white shadow-[0_16px_40px_rgba(217,119,6,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#B45309] md:text-base"
                                data-testid="pricing-download-button"
                            >
                                {p.cta}
                                <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
                            </button>
                            <p className="text-xs leading-relaxed text-[#64748B]" data-testid="pricing-trial-badge">
                                {p.trialBadge} · {p.cardNote}
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
